import setCredentials from './setCredentials';

export default setCredentials;
